// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loader-text {
    padding-top: 50px;
    top: 50%;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    color: #025175;
  }
  
  .loader_wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    z-index: 999999;
    transform: translate(-50%, -50%);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .lds-roller {
    display: inline-block;
    width: 64px;
    position: absolute;
    height: 64px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  
  .lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 32px 32px;
  }
  
  .lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #025175;
    margin: -3px 0 0 -3px;
  }
  
  .lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
  }
  
  .lds-roller div:nth-child(1):after {
    top: 50px;
    left: 50px;
  }
  
  .lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
  }
  
  .lds-roller div:nth-child(2):after {
    top: 54px;
    left: 45px;
  }
  
  .lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
  }
  
  .lds-roller div:nth-child(3):after {
    top: 57px;
    left: 39px;
  }
  
  .lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
  }
  
  .lds-roller div:nth-child(4):after {
    top: 58px;
    left: 32px;
  }
  
  .lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
  }
  
  .lds-roller div:nth-child(5):after {
    top: 57px;
    left: 25px;
  }
  
  .lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
  }
  
  .lds-roller div:nth-child(6):after {
    top: 54px;
    left: 19px;
  }
  
  .lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
  }
  
  .lds-roller div:nth-child(7):after {
    top: 50px;
    left: 14px;
  }
  
  .lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
  }
  
  .lds-roller div:nth-child(8):after {
    top: 45px;
    left: 10px;
  }
  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  ._3uApM {
    display: none !important;
  }
  ._2JvrO {
    background: #025175 !important;
  }
  ._2kL0S {
    background: #025175 !important;
  }
  /* ._2Jtxm {
    background-color: #e7eaf3;
  } */
  
  ._53Ji7 {
    padding: 0rem !important;
  }
  .powredby {
    text-align: center;
  }
  
  .custom-inpt {
    padding: 10px !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/common/helper/Loaders.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,gCAAgC;EAClC;;EAEA;IACE,gEAAgE;IAChE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;;KAEG;;EAEH;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B","sourcesContent":["\n.loader-text {\n    padding-top: 50px;\n    top: 50%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    color: #025175;\n  }\n  \n  .loader_wrapper {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 50%;\n    left: 50%;\n    z-index: 999999;\n    transform: translate(-50%, -50%);\n    border-radius: 0;\n    background: rgba(0, 0, 0, 0.5);\n  }\n  \n  .lds-roller {\n    display: inline-block;\n    width: 64px;\n    position: absolute;\n    height: 64px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n  \n  .lds-roller div {\n    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    transform-origin: 32px 32px;\n  }\n  \n  .lds-roller div:after {\n    content: \" \";\n    display: block;\n    position: absolute;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #025175;\n    margin: -3px 0 0 -3px;\n  }\n  \n  .lds-roller div:nth-child(1) {\n    animation-delay: -0.036s;\n  }\n  \n  .lds-roller div:nth-child(1):after {\n    top: 50px;\n    left: 50px;\n  }\n  \n  .lds-roller div:nth-child(2) {\n    animation-delay: -0.072s;\n  }\n  \n  .lds-roller div:nth-child(2):after {\n    top: 54px;\n    left: 45px;\n  }\n  \n  .lds-roller div:nth-child(3) {\n    animation-delay: -0.108s;\n  }\n  \n  .lds-roller div:nth-child(3):after {\n    top: 57px;\n    left: 39px;\n  }\n  \n  .lds-roller div:nth-child(4) {\n    animation-delay: -0.144s;\n  }\n  \n  .lds-roller div:nth-child(4):after {\n    top: 58px;\n    left: 32px;\n  }\n  \n  .lds-roller div:nth-child(5) {\n    animation-delay: -0.18s;\n  }\n  \n  .lds-roller div:nth-child(5):after {\n    top: 57px;\n    left: 25px;\n  }\n  \n  .lds-roller div:nth-child(6) {\n    animation-delay: -0.216s;\n  }\n  \n  .lds-roller div:nth-child(6):after {\n    top: 54px;\n    left: 19px;\n  }\n  \n  .lds-roller div:nth-child(7) {\n    animation-delay: -0.252s;\n  }\n  \n  .lds-roller div:nth-child(7):after {\n    top: 50px;\n    left: 14px;\n  }\n  \n  .lds-roller div:nth-child(8) {\n    animation-delay: -0.288s;\n  }\n  \n  .lds-roller div:nth-child(8):after {\n    top: 45px;\n    left: 10px;\n  }\n  @keyframes lds-roller {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  ._3uApM {\n    display: none !important;\n  }\n  ._2JvrO {\n    background: #025175 !important;\n  }\n  ._2kL0S {\n    background: #025175 !important;\n  }\n  /* ._2Jtxm {\n    background-color: #e7eaf3;\n  } */\n  \n  ._53Ji7 {\n    padding: 0rem !important;\n  }\n  .powredby {\n    text-align: center;\n  }\n  \n  .custom-inpt {\n    padding: 10px !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
